import { isLeft } from 'fp-ts/Either';
import { pipe } from 'fp-ts/lib/function';
import { failure, parse, string, success, UnknownRecord } from 'io-ts/Decoder';

export const Token = pipe(
	string,
	parse((v) => {
		try {
			const buffer = Buffer.from(v, 'base64').toString();

			const jsonObject = JSON.parse(buffer);

			const decoded = UnknownRecord.decode(jsonObject);

			if (isLeft(decoded)) {
				return failure(v, 'valid lastPageToken');
			} else {
				return success(v);
			}
		} catch {
			return failure(v, 'valid lastPageToken');
		}
	})
);
